<template>
	<c-dialog ref="dialog" title="拒绝发货" width="600">
		<div class="m-refuse-body">
			<div class="m-refuse-label">拒绝发货产品：</div>
			<div class="m-refuse-product">
				<div class="m-refuse-product-name">{{productName || '-'}}</div>
				<div class="m-refuse-product-info">
					<span v-if="produceCode">背贴码：{{produceCode}}</span>
					<span v-if="produceCode && channelName">｜</span>
					<span v-if="channelName">销售渠道：{{channelName}}</span>
				</div>
			</div>

			<div class="m-refuse-form-item">
				<div class="m-refuse-field-label"><span class="m-required">*</span>拒绝发货类型</div>
				<c-select v-model="refuseType" :options="refuseTypeOptions" placeholder="请选择"></c-select>
			</div>

			<div class="m-refuse-form-item">
				<div class="m-refuse-field-label">拒绝原因</div>
				<c-input v-model="refuseReason" placeholder="请输入拒绝原因"></c-input>
			</div>
		</div>

		<template #button>
			<c-button size="dialog" color="main" @click="submitRefuse">确定拒绝</c-button>
			<c-button size="dialog" @click="closeDialog">取消</c-button>
		</template>
	</c-dialog>
</template>

<script>
	export default {
		name: 'saleRefuseShipDialog',

		data() {
			return {
				orderId: '',
				orderNo: '',
				productName: '',
				produceCode: '',
				channelName: '',
				refuseType: '',
				refuseReason: '',
				refuseTypeOptions: []
			}
		},

		mounted() {
			this.loadRefuseTypeOptions();
		},

		methods: {
			/*********加载拒绝发货类型字典**********/
			loadRefuseTypeOptions() {
				this.request({
					url: '/dic/info/options',
					data: {
						dic_type_code: 'REFUSE_SHIP_TYPE'
					},
					success: data => {
						this.refuseTypeOptions = data || [];
					}
				});
			},
			/*********打开弹框**********/
			open(data = {}) {
				this.orderId = data.orderId || '';
				this.orderNo = data.orderNo || '';
				this.productName = data.productName || '';
				this.produceCode = data.produceCode || '';
				this.channelName = data.channelName || '';
				this.refuseType = '';
				this.refuseReason = '';
				this.$refs.dialog.open();
			},

			/*********确定拒绝**********/
			submitRefuse() {
				if (!this.refuseType) {
					this.$message({message: '请选择拒绝发货类型', type: 'warning'});
					return;
				}

				this.request({
					url: '/online/sale/order/refuse_ship',
					data: {
						order_id: this.orderId,
						refuse_type: this.refuseType,
						refuse_reason: this.refuseReason.trim()
					},
					loading: true,
					success: (data, msg) => {
						this.$message({message: msg || '操作成功', type: 'success'});
						this.$refs.dialog.close();
						this.$emit('resolve');
					}
				});
			},

			/*********关闭弹框**********/
			closeDialog() {
				this.$refs.dialog.close();
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-required {
		color: #e53e3e;
		margin-right: 2px;
	}

	.m-refuse-body {
		padding: 20px;

		.m-refuse-label {
			font-size: 13px;
			color: #333;
			margin-bottom: 8px;
		}

		.m-refuse-product {
			background: #f5f7ff;
			border-radius: 4px;
			padding: 16px;
			text-align: center;
			margin-bottom: 20px;

			.m-refuse-product-name {
				color: #3D5EFF;
				font-size: 15px;
				font-weight: 500;
				margin-bottom: 8px;
			}

			.m-refuse-product-info {
				color: #666;
				font-size: 12px;
				display: flex;
				justify-content: center;
				gap: 6px;
				flex-wrap: wrap;
			}
		}

		.m-refuse-form-item {
			margin-bottom: 16px;

			.m-refuse-field-label {
				font-size: 13px;
				color: #333;
				margin-bottom: 8px;
				display: flex;
				align-items: center;
			}
		}
	}
</style>
